import { Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { ReclaimRequest, ReclaimablePublication } from '@/module/Author/Publication/model/PublicationTypes';

import { ReclaimableAuthorList } from '@feature/utils/components/ReclaimableAuthorList';

interface ImportReclaimModalProps {
  close: () => void;
  publication: ReclaimablePublication;

  onReclaimAuthorship: (v: ReclaimRequest) => void;
}

export function ImportReclaimModal({ close, publication, onReclaimAuthorship }: ImportReclaimModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      opened
      onClose={close}
      centered
      size="lg"
      title={t('publications.foundPub')}
    >
      <Stack>
        <Text fw="500">{publication.title}</Text>
        <ReclaimableAuthorList
          authors={publication.authors}
          onReclaim={authorId => onReclaimAuthorship({ authorId, publicationId: publication.id })}
        />
      </Stack>
    </Modal>
  );
}
